export default "__VITE_ASSET__DsMLMaKh__"